import { Route, Routes } from 'react-router-dom';
import { UsersList } from './pages/UsersList';
import { UsersListAdmin } from './pages/UsersListAdmin';
import { PermissionAudits } from './pages/PermissionAudits';
import { UsersDetails } from 'components/UsersDetails';

const UsersModule = () => {
	return (
		<Routes>
			<Route path="/admin" element={<UsersListAdmin />} />
			<Route path="/permission-audits" element={<PermissionAudits />} />
			<Route path="/:userId" element={<UsersDetails />} />
			<Route path="/" element={<UsersList />} />
		</Routes>
	);
};

export default UsersModule;
